__turbopack_context__.v({
  "buyerProtection": "index-module-scss-module__Wy3PEq__buyerProtection",
  "icons": "index-module-scss-module__Wy3PEq__icons",
  "infoBox": "index-module-scss-module__Wy3PEq__infoBox",
  "paymentMethods": "index-module-scss-module__Wy3PEq__paymentMethods",
  "proReturns": "index-module-scss-module__Wy3PEq__proReturns",
  "returnsCopy": "index-module-scss-module__Wy3PEq__returnsCopy",
  "shippingCopy": "index-module-scss-module__Wy3PEq__shippingCopy",
  "shippingCost": "index-module-scss-module__Wy3PEq__shippingCost",
});
